import React, { useState,useEffect } from 'react';
import axios from 'axios';
import { showToast,ToastMessage } from '../../Shared/ToastMessage';
import { baseUrl } from '../../../api/common';
import dayjs from "dayjs";
import SingleFileUpload from '../../common/SingleDropzoneComponent';

const CertificateAdd = ({fetchCertificateData,addPopupStatus, handleAddPopup, eventType, updateData}) => {

  const [updateId, setUpdateId] = useState("");
  const dateFormatList = "YYYY-MM-DD";
  const [formValues, setFormValues] = useState({
    from_date:'', 
    to_date:'', 
    // top_logo:'',
    // bottom_logo:'', 
    president_name:'', 
    // president_sign:'', 
    secretary_name:'',
    // secretary_sign:''
  });

  const [errors, setErrors] = useState({
    from_date:'', 
    to_date:'', 
    top_logo:'',
    bottom_logo:'', 
    president_name:'', 
    president_sign:'', 
    secretary_name:'',
    secretary_sign:''
  });

  const handleInputChange = (field, value) => {
    setFormValues({ ...formValues, [field]: value });
  };

  // const handleTopLogoChange = (event) => {
  //   const file = event.target.files[0];
  //   setFormValues({ ...formValues, top_logo: file }); 
  // };
  // const handleBottomLogoChange = (event) => {
  //   const file = event.target.files[0];
  //   setFormValues({ ...formValues, bottom_logo: file }); 
  // };
  // const handlePresidentSignChange = (event) => {
  //   const file = event.target.files[0];
  //   setFormValues({ ...formValues, president_sign: file }); 
  // };
  // const handleSecretarySignChange = (event) => {
  //   const file = event.target.files[0];
  //   setFormValues({ ...formValues, secretary_sign: file }); 
  // };

    //----------------- Top Logo ----------------
    const [topLogoFile, setTopLogoFile] =useState(null);
    const [topLogoFileError, setTopLogoFileError] =useState("");
    const handleTopLogoUpload = (uploadedFile) => {
      setTopLogoFile(uploadedFile);
      console.log("Uploaded File:", uploadedFile);
    };
    //-------------------------------------------------
    //----------------- Bottom Logo ----------------
    const [bottomLogoFile, setBottomLogoFile] =useState(null);
    const [bottomLogoFileError, setBottomLogoFileError] =useState("");
    const handleBottomLogoUpload = (uploadedFile) => {
      setBottomLogoFile(uploadedFile);
      console.log("Uploaded File:", uploadedFile);
    };
    //-------------------------------------------------  
    
    //----------------- President Sign ----------------
    const [presidentSignFile, setPresidentSignFile] =useState(null);
    const [presidentSignFileError, setPresidentSignFileError] =useState("");
    const handlePresidentSignUpload = (uploadedFile) => {
      setPresidentSignFile(uploadedFile);
      console.log("Uploaded File:", uploadedFile);
    };
    //-------------------------------------------------  

    //----------------- Secretary Sign ----------------
    const [secretarySignFile, setSecretarySignFile] =useState(null);
    const [secretarySignFileError, setSecretarySignFileError] =useState("");
    const handleSecretarySignUpload = (uploadedFile) => {
      setSecretarySignFile(uploadedFile);
      console.log("Uploaded File:", uploadedFile);
    };
    //-------------------------------------------------  

  const validate = () => {
    const newErrors = {
      from_date:'', 
      // to_date:'', 
      // top_logo:'',
      // bottom_logo:'', 
      president_name:'', 
      president_sign:'', 
      secretary_name:'',
      secretary_sign:''
    };  
    if (!formValues.from_date.trim()) {
      newErrors.from_date = 'From date cannot be empty';
    }
    // if (!formValues.to_date.trim()) {
    //   newErrors.to_date = 'To date cannot be empty';
    // }
    if (!formValues.secretary_name.trim()) {
      newErrors.secretary_name = 'Secretary name cannot be empty';
    }
    if (!formValues.president_name.trim()) {
      newErrors.president_name = 'President name cannot be empty';
    }
    // if (!topLogoFile && eventType === "Add") {
    //   newErrors.top_logo = 'Top logo cannot be empty';
    // }
    // if (!bottomLogoFile && eventType === "Add") {
    //   newErrors.bottom_logo = 'Bottom logo cannot be empty';
    // } 
    if (!secretarySignFile && eventType === "Add") {
      newErrors.secretary_sign = 'Secretary sign cannot be empty';
    } 
    if (!presidentSignFile && eventType === "Add") {
      newErrors.president_sign = 'President sign cannot be empty';
    }        
    setErrors(newErrors);
    return Object.values(newErrors).every((error) => error === '');
  };  

  const clearInputValues = () => {
    setErrors({
      from_date:'', 
      // to_date:'', 
      // top_logo:'',
      // bottom_logo:'', 
      president_name:'', 
      president_sign:'', 
      secretary_name:'',
      secretary_sign:''
    });
    setFormValues({
      from_date:'', 
      to_date:'',  
      president_name:'', 
      secretary_name:''
    });
    handleAddPopup(false);
  };  

  const addUpdateCertificate = async () => {
    if (validate()) {
      console.log('Post Data:', formValues); 
      try {
        const requestData = {
          ...formValues,
          // ...{top_logo: topLogoFile || ''},
          // ...{bottom_logo: bottomLogoFile || ''},
          ...{president_sign: presidentSignFile || ''},
          ...{secretary_sign: secretarySignFile || ''},
          ...(eventType === "Update" && { id: updateId }),
        };
        console.log("Update requestData Data:", requestData);
        const response = await axios.post(
          `${baseUrl}/api/certificate_data_update`,
          requestData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: localStorage.getItem('access_token'),
            },
          }
        );
        if (response.data.status) {
          showToast(response.data.message, 'success');
          fetchCertificateData();
          clearInputValues();
        } else {
          showToast(response.data.message, 'error');
        }
      } catch (error) {
        console.error("Error during submission:", error);
        showToast("A network error occurred, or the server is temporarily busy. Please try again later.", "error");
      }
    }else {
      showToast("Please fill in the required details.", "error");
    }
  };

  useEffect(() => {
    if (eventType === "Update" && updateData) {
      console.log("Update Data:", updateData);
      setUpdateId(updateData.id);
      setFormValues({
        from_date: updateData.from_date || '',
        to_date: updateData.to_date || '',
        secretary_name: updateData.secretary_name || '',
        president_name: updateData.president_name || '',
      });
    }else{
      setErrors({
        from_date:'', 
        // to_date:'', 
        // top_logo:'',
        // bottom_logo:'', 
        president_name:'', 
        president_sign:'', 
        secretary_name:'',
        secretary_sign:''
      });
      setFormValues({
        from_date:'', 
        to_date:'', 
        president_name:'', 
        secretary_name:''
      });  
    }
  }, [eventType, updateData, addPopupStatus]);

  return (
    <>
    <ToastMessage/>    
    {addPopupStatus && (
      <div
        className={`extraspace_search_div search_div${addPopupStatus ? ' open' : ''}`}
      >
        <div className="card member_master_sidebar_scrool">
          <div className="member_edit_pop_flex mb-3 text-end">
            <h3>{eventType} Certificate</h3>
            <div className="input-group-append">
              <span
                onClick={() => clearInputValues()}
                className="search_toggle btn btn-danger"
              >
                <i className="fa fa-times" />
              </span>
            </div>
          </div>
          <div className="table-responsive">
            <div className="body application_body_side">
              <div>             
                  <div className="row">
                    <div className="col-md-12">
                      <div className="form-group pos_relative">
                        <label>From Date <span className="text-danger">*</span></label>
                          <input
                            type="date"
                            onClick={(e) => e.target.showPicker()}
                            className={`form-control ${
                              errors.from_date
                                ? "red_border"
                                : ""
                            }`}
                            value={
                              formValues.from_date
                                ? dayjs(
                                  formValues.from_date
                                  ).format(dateFormatList)
                                : ""
                            }
                            onChange={(e) =>
                              handleInputChange(
                                "from_date",
                                e.target.value
                              )
                            }
                          />
                        {errors && (                          
                            <p className="text-danger pos_abos">{errors.from_date}</p>                          
                        )}
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="form-group pos_relative">
                        <label>To Date</label>
                          <input
                            type="date"
                            onClick={(e) => e.target.showPicker()}
                            className={`form-control`}
                            value={
                              formValues.to_date
                                ? dayjs(
                                  formValues.to_date
                                  ).format(dateFormatList)
                                : ""
                            }
                            onChange={(e) =>
                              handleInputChange(
                                "to_date",
                                e.target.value
                              )
                            }
                          />
                        {/* {errors && (                          
                            <p className="text-danger pos_abos">{errors.to_date}</p>                          
                        )} */}
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="form-group pos_relative">
                        <label>President Name <span className="text-danger">*</span></label>
                        <input
                          type="text"
                          className={`form-control ${errors.president_name?"red_border":''}`}
                          value={formValues.president_name}
                          onChange={(e) => handleInputChange('president_name', e.target.value)} 
                          required
                        />
                        {errors && (                          
                            <p className="text-danger pos_abos">{errors.president_name}</p>                          
                        )}
                      </div>

                    </div>
                    <div className="col-md-12">
                      <div className="form-group pos_relative">
                        <label>Secretary Name <span className="text-danger">*</span></label>
                        <input
                          type="text"
                          className={`form-control ${errors.secretary_name?"red_border":''}`}
                          value={formValues.secretary_name}
                          onChange={(e) => handleInputChange('secretary_name', e.target.value)} 
                          required
                        />
                        {errors && (                          
                            <p className="text-danger pos_abos">{errors.secretary_name}</p>                          
                        )}
                      </div>

                    </div>
                    {/* <div className="col-md-12 col-12  pos_relative">
                        <div className="dropdown_cetifica_div">
                          <label>
                            Top Logo{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <br />
                          <small>
                            (Maximum file size allowed: 2MB ){" "}
                          </small>
                        </div>
                        <SingleFileUpload
                          onFileUpload={handleTopLogoUpload}
                          setFileError={setTopLogoFileError}
                          acceptedFilesType='image/jpeg,image/jpg,image/png'
                        />
                        {topLogoFileError && (
                          <p className="text-danger pos_abos left_15">
                            {topLogoFileError}
                          </p>
                        )}
                        {errors && (
                          <p className="text-danger pos_abos left_15">
                            {errors.top_logo}
                          </p>
                        )}
                        <div className="width-fit view_button_list_pos">
                          {eventType === "Update" && updateData && updateData.top_logo && (
                              <a
                                href={`${baseUrl}/${updateData.top_logo}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn btn-outline-info btn-block"
                              >
                                View Document
                              </a>
                            )}
                        </div>
                      </div>
                      <div className="col-md-12 col-12  pos_relative">
                        <div className="dropdown_cetifica_div">
                          <label>
                            Bottom Logo{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <br />
                          <small>
                            (Maximum file size allowed: 2MB ){" "}
                          </small>
                        </div>
                        <SingleFileUpload
                          onFileUpload={handleBottomLogoUpload}
                          setFileError={setBottomLogoFileError}
                          acceptedFilesType='image/jpeg,image/jpg,image/png'
                        />
                        {bottomLogoFileError && (
                          <p className="text-danger pos_abos left_15">
                            {bottomLogoFileError}
                          </p>
                        )}
                        {errors && (
                          <p className="text-danger pos_abos left_15">
                            {errors.bottom_logo}
                          </p>
                        )}
                        <div className="width-fit view_button_list_pos">
                          {eventType === "Update" && updateData && updateData.bottom_logo &&(
                              <a
                                href={`${baseUrl}/${updateData.bottom_logo}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn btn-outline-info btn-block"
                              >
                                View Document
                              </a>
                            )}
                        </div>
                      </div> */}
                      <div className="col-md-12 col-12  pos_relative">
                        <div className="dropdown_cetifica_div">
                          <label>
                          President Sign{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <br />
                          <small>
                            (Maximum file size allowed: 2MB ){" "}
                          </small>
                        </div>
                        <SingleFileUpload
                          onFileUpload={handlePresidentSignUpload}
                          setFileError={setPresidentSignFileError}
                          acceptedFilesType='image/jpeg,image/jpg,image/png'
                        />
                        {presidentSignFileError && (
                          <p className="text-danger pos_abos left_15">
                            {presidentSignFileError}
                          </p>
                        )}
                        {errors && (
                          <p className="text-danger pos_abos left_15">
                            {errors.president_sign}
                          </p>
                        )}
                        <div className="width-fit view_button_list_pos">
                          {eventType === "Update" && updateData && updateData.president_sign &&(
                              <a
                                href={`${baseUrl}/${updateData.president_sign}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn btn-outline-info btn-block"
                              >
                                View Document
                              </a>
                            )}
                        </div>
                      </div>
                      <div className="col-md-12 col-12  pos_relative">
                        <div className="dropdown_cetifica_div">
                          <label>
                          Secretary Sign{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <br />
                          <small>
                            (Maximum file size allowed: 2MB ){" "}
                          </small>
                        </div>
                        <SingleFileUpload
                          onFileUpload={handleSecretarySignUpload}
                          setFileError={setSecretarySignFileError}
                          acceptedFilesType='image/jpeg,image/jpg,image/png'
                        />
                        {secretarySignFileError && (
                          <p className="text-danger pos_abos left_15">
                            {secretarySignFileError}
                          </p>
                        )}
                        {errors && (
                          <p className="text-danger pos_abos left_15">
                            {errors.secretary_sign}
                          </p>
                        )}
                        <div className="width-fit view_button_list_pos">
                          {eventType === "Update" && updateData && updateData.secretary_sign &&(
                              <a
                                href={`${baseUrl}/${updateData.secretary_sign}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn btn-outline-info btn-block"
                              >
                                View Document
                              </a>
                            )}
                        </div>
                      </div>       
                    <div className="col-md-12 member_button_flex">
                      <button onClick={() => addUpdateCertificate()} className="btn btn-outline-info">
                      {eventType}
                      </button>
                      <a
                        onClick={() => clearInputValues()}
                        className="btn btn-outline-danger"
                      >
                        Close
                      </a>
                    </div>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )}
    </>
  );
};

export default CertificateAdd;
